import React, { useRef, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/climbor-die.css';
import '../styles/sections.css';
import '../styles/utilities.css';

import climbOrDieLogo from '../assets/Climb or Die Logo.png';

import {
  Overview,
  GameShowcase,
  Requirements,
  Technologies,
  Screenshots,
  Challenges
} from './ClimbOrDieComponents';

const ClimbOrDie = () => {
  const refs = {
    overview: useRef(null),
    showcase: useRef(null),
    requirements: useRef(null),
    technologies: useRef(null),
    screenshots: useRef(null),
    challenges: useRef(null),
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-white text-gray-800 min-h-screen flex flex-col">
      <Navbar refs={refs} />

      <main className="flex-grow">
        <section className="game-title-section">
          <div className="game-title">
            <img src={climbOrDieLogo} alt="CLIMB OR DIE! Logo" className="game-logo" />
          </div>
        </section>
        
        <section ref={refs.overview}>
          <Overview />
        </section>
        
        <section ref={refs.screenshots}>
          <Screenshots />
        </section>
        
        <section ref={refs.showcase}>
          <GameShowcase />
        </section>
        
        <section ref={refs.requirements}>
          <Requirements />
        </section>
        
        <section ref={refs.technologies}>
          <Technologies />
        </section>
        
        <section ref={refs.challenges}>
          <Challenges />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ClimbOrDie;
